import {
  Companion_getInstance7ri1umalrfbk as Companion_getInstance,
  ServerHealth2sa34lcpyf5qz as ServerHealth,
  Memory2d9txv6h117z7 as Memory,
} from './HealthStatus.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareServerHealthFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ServerHealth_serverId_getInstance(), ServerHealth_version_getInstance(), ServerHealth_memory_getInstance(), ServerHealth_features_getInstance(), ServerHealth_loadAverageCpu_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function ServerHealth_serverId$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function ServerHealth_serverId$_get_name_$ref_o0s9p1() {
  return (p0) => p0.k20();
}
function ServerHealth_serverId$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerHealth_serverId$_get_serializer_$ref_mhdf72() {
  return (p0) => p0.j2j();
}
function ServerHealth_serverId$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function ServerHealth_serverId$_get_annotations_$ref_tg9j6y() {
  return (p0) => p0.bz();
}
var ServerHealth_serverIdClass;
function ServerHealth_serverId() {
  if (ServerHealth_serverIdClass === VOID) {
    class $ {
      constructor() {
        ServerHealth_serverId_instance = this;
        var tmp = this;
        tmp.l3g_1 = lazy(ServerHealth_serverId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m3g_1 = lazy(ServerHealth_serverId$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n3g_1 = lazy(ServerHealth_serverId$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.l3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerHealth_serverId$_get_name_$ref_o0s9p1(), null);
        return tmp0.f2();
      }
      o3g(receiver) {
        return receiver.p3g_1;
      }
      m2j(receiver) {
        return this.o3g(receiver instanceof ServerHealth() ? receiver : THROW_CCE());
      }
      u3g(receiver, value) {
        return receiver.v3g(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ServerHealth() ? receiver : THROW_CCE();
        return this.u3g(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.m3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerHealth_serverId$_get_serializer_$ref_mhdf72(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerHealth_serverId$_get_annotations_$ref_tg9j6y(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerHealth_serverId', VOID, VOID, [SerializableProperty()]);
    ServerHealth_serverIdClass = $;
  }
  return ServerHealth_serverIdClass;
}
var ServerHealth_serverId_instance;
function ServerHealth_serverId_getInstance() {
  if (ServerHealth_serverId_instance === VOID)
    new (ServerHealth_serverId())();
  return ServerHealth_serverId_instance;
}
function ServerHealth_version$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function ServerHealth_version$_get_name_$ref_427lyz() {
  return (p0) => p0.k20();
}
function ServerHealth_version$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerHealth_version$_get_serializer_$ref_7topec() {
  return (p0) => p0.j2j();
}
function ServerHealth_version$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function ServerHealth_version$_get_annotations_$ref_dd8mwg() {
  return (p0) => p0.bz();
}
var ServerHealth_versionClass;
function ServerHealth_version() {
  if (ServerHealth_versionClass === VOID) {
    class $ {
      constructor() {
        ServerHealth_version_instance = this;
        var tmp = this;
        tmp.w3g_1 = lazy(ServerHealth_version$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x3g_1 = lazy(ServerHealth_version$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y3g_1 = lazy(ServerHealth_version$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.w3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerHealth_version$_get_name_$ref_427lyz(), null);
        return tmp0.f2();
      }
      o3g(receiver) {
        return receiver.q3g_1;
      }
      m2j(receiver) {
        return this.o3g(receiver instanceof ServerHealth() ? receiver : THROW_CCE());
      }
      u3g(receiver, value) {
        return receiver.v3g(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ServerHealth() ? receiver : THROW_CCE();
        return this.u3g(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerHealth_version$_get_serializer_$ref_7topec(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerHealth_version$_get_annotations_$ref_dd8mwg(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerHealth_version', VOID, VOID, [SerializableProperty()]);
    ServerHealth_versionClass = $;
  }
  return ServerHealth_versionClass;
}
var ServerHealth_version_instance;
function ServerHealth_version_getInstance() {
  if (ServerHealth_version_instance === VOID)
    new (ServerHealth_version())();
  return ServerHealth_version_instance;
}
function ServerHealth_memory$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function ServerHealth_memory$_get_name_$ref_chfma6() {
  return (p0) => p0.k20();
}
function ServerHealth_memory$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerHealth_memory$_get_serializer_$ref_y0l6tn() {
  return (p0) => p0.j2j();
}
function ServerHealth_memory$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function ServerHealth_memory$_get_annotations_$ref_r250mf() {
  return (p0) => p0.bz();
}
var ServerHealth_memoryClass;
function ServerHealth_memory() {
  if (ServerHealth_memoryClass === VOID) {
    class $ {
      constructor() {
        ServerHealth_memory_instance = this;
        var tmp = this;
        tmp.z3g_1 = lazy(ServerHealth_memory$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a3h_1 = lazy(ServerHealth_memory$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b3h_1 = lazy(ServerHealth_memory$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.z3g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerHealth_memory$_get_name_$ref_chfma6(), null);
        return tmp0.f2();
      }
      o3g(receiver) {
        return receiver.r3g_1;
      }
      m2j(receiver) {
        return this.o3g(receiver instanceof ServerHealth() ? receiver : THROW_CCE());
      }
      c3h(receiver, value) {
        return receiver.v3g(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ServerHealth() ? receiver : THROW_CCE();
        return this.c3h(tmp, value instanceof Memory() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.a3h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerHealth_memory$_get_serializer_$ref_y0l6tn(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b3h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerHealth_memory$_get_annotations_$ref_r250mf(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerHealth_memory', VOID, VOID, [SerializableProperty()]);
    ServerHealth_memoryClass = $;
  }
  return ServerHealth_memoryClass;
}
var ServerHealth_memory_instance;
function ServerHealth_memory_getInstance() {
  if (ServerHealth_memory_instance === VOID)
    new (ServerHealth_memory())();
  return ServerHealth_memory_instance;
}
function ServerHealth_features$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function ServerHealth_features$_get_name_$ref_cxd8p6() {
  return (p0) => p0.k20();
}
function ServerHealth_features$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerHealth_features$_get_serializer_$ref_odb6r5() {
  return (p0) => p0.j2j();
}
function ServerHealth_features$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function ServerHealth_features$_get_annotations_$ref_9rwpud() {
  return (p0) => p0.bz();
}
var ServerHealth_featuresClass;
function ServerHealth_features() {
  if (ServerHealth_featuresClass === VOID) {
    class $ {
      constructor() {
        ServerHealth_features_instance = this;
        var tmp = this;
        tmp.d3h_1 = lazy(ServerHealth_features$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e3h_1 = lazy(ServerHealth_features$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f3h_1 = lazy(ServerHealth_features$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.d3h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerHealth_features$_get_name_$ref_cxd8p6(), null);
        return tmp0.f2();
      }
      o3g(receiver) {
        return receiver.s3g_1;
      }
      m2j(receiver) {
        return this.o3g(receiver instanceof ServerHealth() ? receiver : THROW_CCE());
      }
      g3h(receiver, value) {
        return receiver.v3g(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ServerHealth() ? receiver : THROW_CCE();
        return this.g3h(tmp, (!(value == null) ? isInterface(value, KtMap()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.e3h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerHealth_features$_get_serializer_$ref_odb6r5(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f3h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerHealth_features$_get_annotations_$ref_9rwpud(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerHealth_features', VOID, VOID, [SerializableProperty()]);
    ServerHealth_featuresClass = $;
  }
  return ServerHealth_featuresClass;
}
var ServerHealth_features_instance;
function ServerHealth_features_getInstance() {
  if (ServerHealth_features_instance === VOID)
    new (ServerHealth_features())();
  return ServerHealth_features_instance;
}
function ServerHealth_loadAverageCpu$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function ServerHealth_loadAverageCpu$_get_name_$ref_bv6vku() {
  return (p0) => p0.k20();
}
function ServerHealth_loadAverageCpu$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerHealth_loadAverageCpu$_get_serializer_$ref_cru9l1() {
  return (p0) => p0.j2j();
}
function ServerHealth_loadAverageCpu$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function ServerHealth_loadAverageCpu$_get_annotations_$ref_e3x089() {
  return (p0) => p0.bz();
}
var ServerHealth_loadAverageCpuClass;
function ServerHealth_loadAverageCpu() {
  if (ServerHealth_loadAverageCpuClass === VOID) {
    class $ {
      constructor() {
        ServerHealth_loadAverageCpu_instance = this;
        var tmp = this;
        tmp.h3h_1 = lazy(ServerHealth_loadAverageCpu$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i3h_1 = lazy(ServerHealth_loadAverageCpu$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j3h_1 = lazy(ServerHealth_loadAverageCpu$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.h3h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerHealth_loadAverageCpu$_get_name_$ref_bv6vku(), null);
        return tmp0.f2();
      }
      o3g(receiver) {
        return receiver.t3g_1;
      }
      m2j(receiver) {
        return this.o3g(receiver instanceof ServerHealth() ? receiver : THROW_CCE());
      }
      k3h(receiver, value) {
        return receiver.v3g(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ServerHealth() ? receiver : THROW_CCE();
        return this.k3h(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i3h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerHealth_loadAverageCpu$_get_serializer_$ref_cru9l1(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j3h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerHealth_loadAverageCpu$_get_annotations_$ref_e3x089(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerHealth_loadAverageCpu', VOID, VOID, [SerializableProperty()]);
    ServerHealth_loadAverageCpuClass = $;
  }
  return ServerHealth_loadAverageCpuClass;
}
var ServerHealth_loadAverageCpu_instance;
function ServerHealth_loadAverageCpu_getInstance() {
  if (ServerHealth_loadAverageCpu_instance === VOID)
    new (ServerHealth_loadAverageCpu())();
  return ServerHealth_loadAverageCpu_instance;
}
//region block: exports
export {
  prepareServerHealthFields as prepareServerHealthFields25n3y2v2tv5cq,
};
//endregion

//# sourceMappingURL=ServerHealthFields.mjs.map
